export type ChatProvider = "azure" | "openrouter" | "ollama" | "vllm" | "junet" | "openai" | "anthropic";
export const availableChatProviders = ["azure", "openrouter", "ollama", "vllm", "junet", "openai", "anthropic"] as const;


export const chatProviderMap: Record<ChatProvider, {label: string; value: string; image: string;}> = {
    azure: {
        label: "Azure OpenAI",
        value: "azure",
        image: "/assets/providers/azure.svg",
    },
    openai: {
        label: "OpenAI",
        value: "openai",
        image: "/assets/providers/openai.svg",
    },
    anthropic: {
        label: "Anthropic",
        value: "anthropic",
        image: "/assets/providers/anthropic.svg",
    },
    openrouter: {
        label: "OpenRouter",
        value: "openrouter",
        image: "/assets/providers/openrouter.svg",
    },
    ollama: {
        label: "Ollama",
        value: "ollama",
        image: "/assets/providers/ollama.svg",
    },
    vllm: {
        label: "vLLM",
        value: "vllm",
        image: "/assets/providers/vllm.svg",
    },
    junet: {
        label: "Junet Core",
        value: "junet",
        image: "/favicon.png",
    },
}